module.exports = __webpack_public_path__ + "static/img/29b.7a3a209.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/29b.jpg
// module id = RXSb
// module chunks = 1